module.exports = __webpack_public_path__ + "img/1485572195.ff2c7ce8.jpg";